document.addEventListener('DOMContentLoaded', function () {
    const purchasesContainer = document.getElementById('optional-purchase-prices-container');
    const addPurchaseFieldButton = document.getElementById('add-purchase-field');
    const trophyPricesContainer = document.getElementById('trophy-prices-container');
    const addTrophyFieldButton = document.getElementById('add-trophy-field');
    const totalPriceField = document.querySelector('input[name="TotalPrice"]');
    const huntingPriceField = document.querySelector('input[name="HuntingPrice"]');
    const trophyPriceField = document.querySelector('input[name="TrophyPrice"]');
    const administrationFeesField = document.querySelector('input[name="AdministrationFees"]');
    const extraDaysYes = document.getElementById('ExtraDaysYes');
    const extraDaysNo = document.getElementById('ExtraDaysNo');
    const fields = {
        extraHuntingDays: document.querySelector('input[name="ExtraHuntingDays"]'),
        extraStayDays: document.querySelector('input[name="ExtraStayDays"]'),
        companionDays: document.querySelector('input[name="CompanionDays"]')
    };
    const noAdditionalPurchaseCheckbox = document.getElementById('no-additional-purchase');
    const optionalPurchasesCheckboxes = document.querySelectorAll('.optional-purchase');
    const priceDropdown = document.getElementById('pricePackageDropdown');

    // Function to enable/disable optional purchases based on the "No Additional Purchases" checkbox
    function toggleOptionalPurchases() {
        const isDisabled = noAdditionalPurchaseCheckbox.checked;
        optionalPurchasesCheckboxes.forEach(checkbox => {
            checkbox.disabled = isDisabled;

            // Uncheck the optional purchases if "Ingen ekstra tilk�b" is checked
            if (isDisabled) {
                checkbox.checked = false;
            }
        });
    }

    // Function to update the hunt price field
    function updateHuntPriceField() {
        if (priceDropdown) {
            var selectedValue = priceDropdown.value; // Get the selected option's value (which is the price)
            var price = parseFloat(selectedValue);   // Convert it to a float (or integer, depending on your needs)

            // Update the price field with the parsed price
            if (!isNaN(price)) {
                huntingPriceField.value = price;
            } else {
                huntingPriceField.value = '';  // Clear the field if no valid price
            }
            calculateTotalPrice();
        }
    }

    // Function to calculate total price
    function calculateTotalPrice() {
        let totalPrice = [
            huntingPriceField,
            trophyPriceField,
            administrationFeesField
        ].reduce((sum, field) => sum + (parseInt(field?.value) || 0), 0);

        // Add up optional purchase prices
        purchasesContainer.querySelectorAll('input[name^="OptionalPurchasePrices"]').forEach(field => {
            totalPrice += parseInt(field.value) || 0;
        });

        // Add up trophy prices
        trophyPricesContainer.querySelectorAll('input[name^="TrophyPrices"]').forEach(field => {
            totalPrice += parseInt(field.value) || 0;
        });

        totalPriceField.value = totalPrice;
    }

    // Function to add a new pair of fields (name and price) with an optional removal button
    function addField(container, nameFieldName, priceFieldName, index) {
        const newField = document.createElement('div');
        newField.classList.add('mb-2', 'd-flex', 'align-items-center');

        // Create a helper function to create input fields
        const createInput = (type, name, placeholder, width) => {
            const input = document.createElement('input');
            input.type = type;
            input.name = `${name}[${index}]`;
            input.classList.add('form-control', 'mr-2');
            input.placeholder = placeholder;
            input.style.width = width;
            return input;
        };

        // Name and Price fields
        const nameInputField = createInput('text', nameFieldName, 'Indtast navn', '70%');
        const priceInputField = createInput('number', priceFieldName, 'Indtast pris', '30%');

        // Recalculate total price on input change
        priceInputField.addEventListener('input', calculateTotalPrice);

        // Remove field button
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.classList.add('btn', 'btn-danger');
        removeButton.innerHTML = '-';
        removeButton.addEventListener('click', function () {
            newField.remove();
            calculateTotalPrice();
        });

        // Append elements
        newField.appendChild(nameInputField);
        newField.appendChild(priceInputField);
        newField.appendChild(removeButton);
        container.appendChild(newField);
    }

    // Function to enable/disable the fields based on whether "Ja" or "Nej" is selected
    function toggleExtraDaysFields() {
        const isEnabled = extraDaysYes.checked;
        Object.values(fields).forEach(field => {
            field.disabled = !isEnabled;
            if (!isEnabled) field.value = 0;
        });
    }

    // Event listeners for button clicks to add new fields
    addPurchaseFieldButton?.addEventListener('click', function () {
        addField(purchasesContainer, 'OptionalPurchaseNames', 'OptionalPurchasePrices', purchasesContainer.childElementCount);
    });

    addTrophyFieldButton?.addEventListener('click', function () {
        addField(trophyPricesContainer, 'TrophyNames', 'TrophyPrices', trophyPricesContainer.childElementCount);
    });

    // Event listeners for recalculating the total price
    [huntingPriceField, trophyPriceField].forEach(field => {
        field?.addEventListener('input', calculateTotalPrice);
    });

    // Event listeners for extra days fields
    [extraDaysYes, extraDaysNo].forEach(radio => {
        radio?.addEventListener('change', toggleExtraDaysFields);
    });

    // Add an event listener to update the hunt price when the dropdown value changes
    if (priceDropdown) {
        priceDropdown.addEventListener('change', updateHuntPriceField);
    }

    // Event listener for when the "No Additional Purchases" checkbox changes
    noAdditionalPurchaseCheckbox.addEventListener('change', toggleOptionalPurchases);

    // Initialize total price and extra days state on page load
    updateHuntPriceField();
    calculateTotalPrice();
    toggleExtraDaysFields();
    toggleOptionalPurchases();
});
